var Backbone, CallBackErrorView, SupportCallBackErrorTemplate, SupportProgressBarView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportProgressBarView = require('../../progress_bar_view.coffee');

SupportCallBackErrorTemplate = require('../../../../call_back_error.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

CallBackErrorView = (function(superClass) {
  extend(CallBackErrorView, superClass);

  function CallBackErrorView() {
    return CallBackErrorView.__super__.constructor.apply(this, arguments);
  }

  CallBackErrorView.prototype.initialize = function(options) {
    this.options = options || {};
    this.isLivingsocial = window.brand === "livingsocial";
    this.I18nScope = 'modules.support';
    this.template = SupportCallBackErrorTemplate;
    this.contactChannelTextView = this.options.contactChannelTextView;
    return this.showAfterHoursMessage = this.options.showAfterHoursMessage;
  };

  CallBackErrorView.prototype.render = function() {
    this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
    this.contactChannelTextView.render();
    this.contactChannelTextView.$el.removeClass();
    this.renderProgressBar();
    return this.$el.find(".contact-channel-container").html(this.contactChannelTextView.el);
  };

  CallBackErrorView.prototype.toHash = function() {
    return {
      showAfterHoursMessage: this.showAfterHoursMessage,
      isLivingsocial: this.isLivingsocial
    };
  };

  CallBackErrorView.prototype.renderProgressBar = function() {
    var progressBar;
    progressBar = new SupportProgressBarView;
    progressBar.render();
    return this.$el.find('.steps-container').append(progressBar.el);
  };

  CallBackErrorView.prototype.postRenderhandler = function() {
    return this.contactChannelTextView.renderLiveChat();
  };

  return CallBackErrorView;

})(Backbone.View);

module.exports = CallBackErrorView;

//# sourceMappingURL=data:application/json;base64,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
